import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IAttendeesDAO } from '../../../../api/attendees.dao';

export class DeleteAttendeeJob extends JobConfiguration {
    public readonly type = JobType.DeleteAttendee;
    public readonly name = 'Delete Attendee';
    public readonly description = 'Attendee Deletion';

    public async execute(execParams) {
        return IoC.Container.get(IAttendeesDAO).deleteAttendee(execParams);
    }
}

export default {
    [JobType.DeleteAttendee]: DeleteAttendeeJob
};
